import React from 'react';
import { Carousel } from 'primereact/carousel';
import './PartnerCarousel.css';

import sesLogo from '../assets/SES_Logo_Horizontal_White_RGB2.png';
import tpLogo from '../assets/TP.png';
import novaspaceLogo from '../assets/novaspace_logo.png';
import neustarkLogo from '../assets/neustark_logo_w2.png'

interface Company {
    name: string;
    logo: string;
    link: string;
}

const companies: Company[] = [
    { name: 'SES', logo: sesLogo, link: 'https://www.ses.com' },
    { name: 'Novaspace', logo: novaspaceLogo, link: 'https://nova.space' },
    { name: 'Terraprisma', logo: tpLogo, link: 'https://terraprisma.com/' },
    { name: 'Neustark', logo: neustarkLogo, link: 'https://neustark.com'}
];

const PartnersCarousel: React.FC = () => {

    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '560px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    const companyTemplate = (company: Company) => {
        return (
            <div className="company-item">
                <a href={company.link}
                    target="_blank"
                    rel="noopener noreferrer">
                    <img className="company-logo" src={company.logo} alt={company.name} />
                </a>
            </div>
        );
    };

    return (
        <div className="trusted-partners-carousel">
            <Carousel
                value={companies}
                numVisible={3}
                numScroll={1}
                circular
                autoplayInterval={3000}
                responsiveOptions={responsiveOptions}
                itemTemplate={companyTemplate}
                showIndicators={false}
                showNavigators={true}
            />
        </div>
    );
};

export default PartnersCarousel;
